// Define default search values
export const searchValues = {
  title: "",
  isDonor: "",
  donorStatus: "",
  stopMessageGroup: "",
};

// Define Excel header cell names mapping
export const excelHeaderCellsName = {
  "المعرف": "id",
  "نشط": "isActive",
  "الاسم": "displayName",
  "رقم الهاتف": "phone",
  "البريد الإلكتروني": "email",
};
